// OTPModal.jsx
import Modal from 'react-modal';
import { useState, useRef } from 'react';

Modal.setAppElement('#root');

const OTPModal = ({ isOpen, onRequestClose, onSubmit, sendOTP }) => {
    const [digits, setDigits] = useState(['', '', '', '']);
    const inputRefs = useRef([]);

    const handleChange = (e, idx) => {
        const value = e.target.value;
        if (/^\d?$/.test(value)) {
            const newDigits = [...digits];
            newDigits[idx] = value;
            setDigits(newDigits);

            if (value && idx < inputRefs.current.length - 1) {
                inputRefs.current[idx + 1]?.focus();
            }
        }
    };

    const handleKeyDown = (e, idx) => {
        if (e.key === 'Backspace' && digits[idx] === '') {
            if (idx > 0) {
                const newDigits = [...digits];
                newDigits[idx - 1] = '';
                setDigits(newDigits);
                inputRefs.current[idx - 1]?.focus();
            }
        }
    };

    return (
        <Modal
            isOpen={!!isOpen?.DEMO_CAMPAIGN_ID}
            onRequestClose={onRequestClose}
            className="max-w-md m-auto bg-[white] rounded-3xl p-6 shadow-lg outline-none"
            overlayClassName="z-[1000] fixed inset-0 bg-[black] bg-opacity-40 flex justify-center items-start"
        >
            <button type='button' onClick={onRequestClose} className="text-xl mb-4">&larr;</button>
            <div className='px-12'>
                <h2 className="text-xl font-semibold mb-2 text-center">Enter OTP</h2>
                <p className="text-sm text-[gray] text-center">
                    We’ve sent a 6-digit verification code to
                </p>
                <p className="text-sm text-[black] text-center mb-4">
                    {isOpen?.MOBILE_NUMBER}
                </p>

                <div className="flex justify-center space-x-2 mb-4">
                    {Array.from({ length: 4 }).map((_, idx) => (
                        <div key={idx} className="border border-[gray] rounded-lg">
                            <input
                                ref={(el) => (inputRefs.current[idx] = el)}
                                maxLength={1}
                                className="w-10 h-10 rounded-lg text-center text-lg"
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={digits[idx]}
                                onChange={(e) => handleChange(e, idx)}
                                onKeyDown={(e) => handleKeyDown(e, idx)}
                            />
                        </div>
                    ))}
                </div>

                <p className="text-sm text-center text-gray-500 mb-4">
                    Didn’t receive a code? <button type='button' onClick={sendOTP} className="font-semibold text-smd_blue-normal hover:underline">Send again</button>
                </p>
            </div>

            <button
                disabled={digits?.join("").length < 4}
                type='button'
                onClick={() => onSubmit({ ...isOpen, OTP: digits?.join("") })}
                className="w-full bg-smd_blue-normal text-[white] py-4 rounded-xl transition text-[2vh]"
            >
                Verify Code
            </button>

            <button
                type='button'
                onClick={onRequestClose}
                className="font-semibold mt-4 text-sm text-smd_blue-normal hover:underline w-full text-center"
            >
                Change mobile number
            </button>
        </Modal>
    );
};

export default OTPModal;
